import { Component, Type } from '@angular/core';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';
import { OmniLiveAvailabilityFacade } from '@cigna/omni/live-availability-state';
import { ChatBubbleFacade } from '@cigna/omni/chat-bubble';
import { OmniChatFacade } from '@cigna/omni/chat-state';
import {
  IconDynamicChevronComponent,
  IconDynamicColors,
  IconDynamicData,
  IconsDynamic,
  omniConfig,
} from '@cigna/omni/shared';

@Component({
  selector: 'cigna-omni-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent {
  public Icon: Type<IconsDynamic> = IconDynamicChevronComponent;
  public IconData: IconDynamicData = {
    direction: 'right',
  };
  public iconColors: IconDynamicColors = {
    color: omniConfig.omniColors.blue,
  };

  public liveChatAvailable$ = this.liveAvailableFacade.liveChatAvailable$;
  public chatCloseHrsMsg$ = this.liveAvailableFacade.chatCloseHrsMsg$;
  public unreadDMConversationCount$ =
    this.conversationsFacade.unreadDMConversationCount$;

  constructor(
    private conversationsFacade: OmniConversationsFacade,
    private liveAvailableFacade: OmniLiveAvailabilityFacade,
    private chatBubbleFacade: ChatBubbleFacade,
    private chatFacade: OmniChatFacade,
  ) {}

  launchLiveChat() {
    this.chatBubbleFacade.launchChat('chat');
  }

  openActiveDMs() {
    this.chatFacade.openActiveDMsView();
  }
}
